import { partByLineType } from "../api-detour";
import { sketchControlPoint, TRACK_Z_INDEX } from "./common";
import { pedestrianBanIcon } from "./icons";

export const detourClosedWay = [
  {
    "stroke-width": 12,
    "stroke-color": [255, 255, 255, 0.8],
  },
  {
    "stroke-width": 12,
    "stroke-color": [255, 0, 0, 0.8],
    "stroke-line-dash": [10, 30],
    "stroke-line-cap": "square",
    "stroke-line-join": "miter",
  },
];

const closedWayControlPoint = {
  "z-index": TRACK_Z_INDEX,
  "circle-radius": 8,
  "circle-fill-color": "#fff",
  "circle-stroke-color": "#f00",
  "circle-stroke-width": 2,
};

export const detourStartEndPoint = {
  "icon-src": `data:image/svg+xml;utf8, ${encodeURIComponent(pedestrianBanIcon)}`,
  "z-index": 20,
};

/*
 * Detour line style
 */

// Detour line

export const detourLine = {
  "stroke-width": 12,
  "stroke-color": [249, 181, 0, 0.8],
};

// Detour line control point

const detourLineControlPoint = {
  "z-index": TRACK_Z_INDEX,
  "circle-radius": 8,
  "circle-fill-color": "#fff",
  "circle-stroke-color": [249, 181, 0, 0.8],
  "circle-stroke-width": 2,
};

// Detour line first stop over

const controlPointBackground = {
  "circle-radius": 13,
  "circle-fill-color": "#fff",
};

const firstStopOverCircle1 = {
  "circle-radius": 6,
  "circle-fill-color": [249, 181, 0, 0.8],
};

const firstStopOverCircle2 = {
  "circle-radius": 9,
  "circle-fill-color": "#fff",
};

const firstStopOverCircle3 = {
  "circle-radius": 12,
  "circle-fill-color": [249, 181, 0, 0.8],
};

const detourLineFirstStopOver = [
  controlPointBackground,
  firstStopOverCircle3,
  firstStopOverCircle2,
  firstStopOverCircle1,
];

// Detour line last stop over

const lastStopOverCircle1 = {
  "circle-radius": 6,
  "circle-fill-color": "#fff",
};

const lastStopOverCircle2 = {
  "circle-radius": 12,
  "circle-fill-color": [249, 181, 0, 0.8],
};

const detourLineLastStopOver = [controlPointBackground, lastStopOverCircle2, lastStopOverCircle1];

export const detourStyle = [
  {
    filter: ["==", ["get", "type"], "sketch"],
    style: sketchControlPoint,
  },
  {
    filter: ["all", ["==", ["get", "part"], partByLineType.closed_way_line], ["!=", ["get", "subtype"], "modifying"]],
    style: detourClosedWay,
  },
  {
    filter: ["all", ["==", ["get", "part"], partByLineType.detour_line], ["!=", ["get", "subtype"], "modifying"]],
    style: detourLine,
  },
  {
    filter: [
      "all",
      ["==", ["get", "part"], partByLineType.closed_way_line],
      ["==", ["get", "type"], "controlPoint"],
      ["==", ["coalesce", ["get", "subtype"], false], false],
    ],
    style: closedWayControlPoint,
  },
  {
    filter: [
      "all",
      ["==", ["get", "part"], partByLineType.detour_line],
      ["==", ["get", "type"], "controlPoint"],
      ["==", ["coalesce", ["get", "subtype"], false], false],
    ],
    style: detourLineControlPoint,
  },
  {
    filter: ["all", ["==", ["get", "part"], partByLineType.detour_line], ["==", ["get", "subtype"], "first"]],
    style: detourLineFirstStopOver,
  },
  {
    filter: ["all", ["==", ["get", "part"], partByLineType.detour_line], ["==", ["get", "subtype"], "last"]],
    style: detourLineLastStopOver,
  },
  {
    filter: [
      "all",
      ["==", ["get", "part"], partByLineType.closed_way_line],
      ["any", ["==", ["get", "subtype"], "first"], ["==", ["get", "subtype"], "last"]],
    ],
    style: detourStartEndPoint,
  },
];
